<template>
  <div class="relative">
    <!-- 모델 선택 버튼 -->
    <button
      @click.stop="toggleDropdown"
      class="flex items-center justify-between px-3 py-1 border rounded-lg"
      :class="[
        disabled ? 'bg-gray-100 cursor-not-allowed' : 'hover:bg-gray-50',
        disabled ? 'opacity-75' : ''
      ]"
      :disabled="disabled"
      title="모델 선택"
    >
      <span class="truncate">{{ currentModel?.name || placeholder }}</span>
      <span class="material-icons flex-shrink-0" v-if="!disabled">
        {{ isOpen ? 'expand_less' : 'expand_more' }}
      </span>
    </button>

    <!-- 드롭다운 메뉴 -->
    <div
      v-if="isOpen && !disabled"
      class="absolute left-0 mt-1 bg-white rounded-lg shadow-lg border border-gray-200 py-2 dropdown-menu overflow-y-auto"
      style="z-index: 9999; min-width: 190px; max-height: 190px;"
      @click.stop
    >
      <!-- 모델 목록 -->
      <div class="py-1">
        <button
          v-for="model in models"
          :key="model.id"
          @click.stop="selectModel(model)"
          class="w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center gap-2 justify-between"
          :title="model.name"
        >
          <div class="flex items-center gap-2">
            <span class="material-icons text-base">
              {{ model.id === 'gpt-4' ? 'auto_awesome' : 'bolt' }}
            </span>
            <span class="truncate">{{ model.name }}</span>
          </div>
          <span v-if="model.id === currentModel?.id" class="material-icons text-blue-400">
            check
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { modelAPI } from '@/utils/api'
import { getAllSupportedModels } from '@/utils/models'

export default {
  name: 'AppModelSelect',
  props: {
    selectedModel: {
      type: Object,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '모델 선택'
    },
    resetOnNewChat: {
      type: Boolean,
      default: false
    },
    dropdownOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      models: getAllSupportedModels(),
      internalSelectedModel: null
    }
  },
  computed: {
    currentModel() {
      return this.selectedModel || this.internalSelectedModel
    }
  },
  methods: {
    selectModel(model) {
      if (this.disabled) return
      this.internalSelectedModel = model
      this.$emit('select-model', model)
      this.isOpen = false
    },
    closeDropdown(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false
      }
    },
    toggleDropdown() {
      if (this.disabled) return
      if (!this.isOpen) {
        this.$emit('dropdown-opened')
      }
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        this.$emit('dropdown-opened')
      }
    },
    async fetchModels() {
      try {
        const response = await modelAPI.getModels()
        this.models = response.data
      } catch (error) {
        console.error('모델 목록 조회 중 오류 발생:', error)
      }
    },
    resetModel() {
      if (this.resetOnNewChat) {
        this.internalSelectedModel = null
        this.$emit('select-model', null)
      }
    }
  },
  async created() {
    // 모델 목록을 하드코딩으로 할당하므로 fetchModels() 호출 불필요
  },
  mounted() {
    document.addEventListener('click', this.closeDropdown)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeDropdown)
  },
  watch: {
    selectedModel: {
      handler(newVal) {
        if (newVal === null && this.resetOnNewChat) {
          this.internalSelectedModel = null
        }
      },
      immediate: true
    },
    disabled: {
      handler(newVal) {
        if (newVal) {
          this.isOpen = false
        }
      },
      immediate: true
    },
    dropdownOpen(val) {
      if (!val) {
        this.isOpen = false
      }
    }
  }
}
</script>

<style scoped>
/* 드롭다운 메뉴 스크롤바 스타일 */
.dropdown-menu::-webkit-scrollbar {
  width: 6px;
}

.dropdown-menu::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dropdown-menu::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dropdown-menu::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* Firefox 스크롤바 스타일 */
.dropdown-menu {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}
</style> 